import React, { useState, useEffect } from 'react';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import '../../sass/components/flexibleModules/_components.genericTwoColumnMastheadSectionWithoutGrid.scss';
import iconPredict from '../../images/rotate-icon-predict.svg';
import MarketoFormComponent from '../marketo/marketoFormComponent';

const GenericTwoColumnMastheadSectionWithoutGrid = ({ data }) => {

    const [videoShow, setVideoShow] = useState(false);
    const showVideo = (val) => {
        setVideoShow(val);
    }

    const [marketoFormShow, setMarketoFormShow] = useState(false);
    const showMarketoForm = (val) => {
        setMarketoFormShow(val);
    }

    useEffect(() => {
        if (data.genericTwoColumnMastheadButtonTwo && data.genericTwoColumnMastheadButtonTwo.url === '#wistiaVideo') {
            var scriptOne = document.createElement('script');
            scriptOne.src = '//fast.wistia.com/embed/medias/vvuoe0gio0.jsonp';
            scriptOne.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptOne);
            var scriptTwo = document.createElement('script');
            scriptTwo.src = '//fast.wistia.com/assets/external/E-v1.js';
            scriptTwo.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptTwo);
        }
    }, []);

    return (
        <div className={`cp-genericGridTwoColumnMastheadWithoutGrid l-${data.textColor} ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericGridTwoColumnMastheadWithoutGrid__inner l--flex" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.overrideClass &&
                    <>
                        {data.overrideClass === 'l-predictTrial' &&
                            <>
                                <span className="l-absoluteIcon l-absoluteIcon1">
                                    <StaticImage src="../../images/green-circle-pattern.svg" alt="pattern" />
                                </span>
                                <span className="l-absoluteIcon l-absoluteIcon2">
                                    <StaticImage src="../../images/svgpattern2.svg" alt="pattern" />
                                </span>
                            </>
                        }
                    </>
                }
                <div className="cp-twoColumnWithoutGrid__left">
                    <h1 dangerouslySetInnerHTML={{ __html: data.genericTwoColumnMastheadTitle }} />
                    <p dangerouslySetInnerHTML={{ __html: data.genericTwoColumnMastheadTeaser }} />
                    {data.genericTwoColumnMastheadBulletPoints &&
                        <ul>
                            {data.genericTwoColumnMastheadBulletPoints.map((bullet, index) => (
                                <li key={index}>{bullet.text}</li>
                            ))}
                        </ul>
                    }
                    <div className="l--flex">
                        {data.genericTwoColumnMastheadButton &&
                            <>
                                {
                                    data.genericTwoColumnMastheadButton.url === '#cp-marketo' ?
                                        <div className="l-relativeButton" onClick={() => showMarketoForm(true)}>
                                            <button className="l-button">{data.genericTwoColumnMastheadButton.title}</button>
                                            <button className="l-button l-backgroundHover">{data.genericTwoColumnMastheadButton.title}</button>
                                        </div>
                                        :
                                        <div className="l-relativeButton">
                                            <a className="l-button" href={data.genericTwoColumnMastheadButton.url} target={data.genericTwoColumnMastheadButton.target}>{data.genericTwoColumnMastheadButton.title}</a>
                                            <a className="l-button l-backgroundHover" href={data.genericTwoColumnMastheadButton.url} target={data.genericTwoColumnMastheadButton.target}>{data.genericTwoColumnMastheadButton.title}</a>
                                        </div>
                                }
                            </>
                        }
                        {data.genericTwoColumnMastheadButtonTwo &&
                            <>
                                {data.genericTwoColumnMastheadButtonTwo.url === '#wistiaVideo' ?
                                    <div className="l-relativeButton" onClick={() => showVideo(true)}>
                                        <button className="l-button">{data.genericTwoColumnMastheadButtonTwo.title}</button>
                                        <button className="l-button l-backgroundHover">{data.genericTwoColumnMastheadButtonTwo.title}</button>
                                    </div>
                                    :
                                    <div className="l-relativeButton">
                                        <a className="l-button" href={data.genericTwoColumnMastheadButtonTwo.url} target={data.genericTwoColumnMastheadButtonTwo.target}>{data.genericTwoColumnMastheadButtonTwo.title}</a>
                                        <a className="l-button l-backgroundHover" href={data.genericTwoColumnMastheadButtonTwo.url} target={data.genericTwoColumnMastheadButtonTwo.target}>{data.genericTwoColumnMastheadButtonTwo.title}</a>
                                    </div>
                                }
                            </>
                        }
                    </div>
                </div>
                <div className="cp-twoColumnWithoutGrid__right">
                    {data.genericTwoColumnMastheadImage &&
                        <GatsbyImage image={getImage(data.genericTwoColumnMastheadImage.gatsbyImage)} alt={data.genericTwoColumnMastheadImage.altText} />
                    }
                    {data.overrideClass &&
                        <>
                            {data.overrideClass === 'l-predictTrial' &&
                                <>
                                    <span className="l-absoluteIcon l-absoluteIcon1">
                                        <img src={iconPredict} alt="pattern" />
                                    </span>
                                </>
                            }
                        </>
                    }
                </div>

                {marketoFormShow &&
                    <div className="cp-postPerformEventIntro__formVideo l--flex l--abtestOverride">
                        <div className="cp-postPerformEventIntro__formVideo-left" id="l-leftForm">
                            {data.overrideClass === 'l-predictTrial l-powerbiPage' ?
                                <MarketoFormComponent formSubmitMessage="Thank you for your submission" formId="3714" />
                                :
                                <MarketoFormComponent formSubmitMessage="Thank you for your submission" formId="3702" />
                            }
                            <button onClick={() => showMarketoForm(false)} className="l-backgroundTrigger"></button>
                        </div>
                    </div>
                }

                {videoShow &&
                    <div className="cp-postPerformEventIntro__formVideo l--flex l--abtestOverride">
                        <div className="cp-postPerformEventIntro__formVideo-left" id="l-leftForm">
                            <div className="l-modalVideo">
                                <div className={`wistia_embed wistia_async_vvuoe0gio0 autoPlay=true`}>&nbsp;</div>
                            </div>
                            <button onClick={() => showVideo(false)} className="l-backgroundTrigger"></button>
                        </div>
                    </div>
                }

            </div>
        </div>
    );
}

export default GenericTwoColumnMastheadSectionWithoutGrid;